import axios from 'axios';

const resetPasswordRequest = (data) => (
  axios.post(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/v2/auth/password/reset-request`,
    data,
  ));

export default resetPasswordRequest;
